export default __webpack_public_path__ + "static/media/bg_mobile.14fe281b.png";